/** Keep numeric values in sync with web/tokens.css */

export const UI = {
  font: {
    "2xs": 10,
    xs: 12,
    sm: 13,
    base: 14,
    md: 16,
    lg: 20,
    xl: 26,
    "2xl": 34,
  },
  space: {
    0: 2,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 32,
    8: 40,
  },
  radius: {
    sm: 6,
    md: 10,
    lg: 16,
  },
} as const;

const FONT_FAMILY = "'Trebuchet MS', sans-serif";

export function uiFont(
  weight: number | string,
  step: keyof typeof UI.font,
): string {
  return `${weight} ${UI.font[step]}px ${FONT_FAMILY}`;
}

/**
 * "Void-touched" purple gradient stops for admin name styling.
 * Kept in sync with the `.admin-name` CSS gradient in web/style.css.
 */
export const VOID_NAME_STOPS = ["#e9b8ff", "#b15cff", "#7a2bff"] as const;

/** Horizontal canvas gradient across [x, x + width] for admin "void-touched" names. */
export function voidNameGradient(
  c: CanvasRenderingContext2D,
  x: number,
  width: number,
): CanvasGradient {
  const g = c.createLinearGradient(x, 0, x + Math.max(1, width), 0);
  g.addColorStop(0, VOID_NAME_STOPS[0]);
  g.addColorStop(0.5, VOID_NAME_STOPS[1]);
  g.addColorStop(1, VOID_NAME_STOPS[2]);
  return g;
}
